export enum TRANSLATION_KEYS {
  REQUIRED_FIRSTNAME = 'register.error.requiredFirstName',
  REQUIRED_LASTNAME = 'register.error.requiredLastName',
  REQUIRED_BIRTHDATE = 'register.error.requiredBirthDate',
  REQUIRED_COUNTRY_CODE = 'register.error.requiredCountry',
  INVALID_FORMAT = 'register.error.invalidFormat',
  INVALID_FIRSTNAME_FORMAT = 'register.error.invalidFirstName',
  INVALID_LASTNAME_FORMAT = 'register.error.invalidLastName',
  INVALID_PHONENUMER_FORMAT = 'register.error.invalidPhoneNumber',
  INVALID_BIRTH_DATE = 'register.error.invalidBirthDate',
  INVALID_GENDER = 'register.error.missingGender',
  INVALID_GENDER_CUSTOM = 'register.error.invalidGenderCustom',
  INVALID_BOX_FORMAT = 'register.error.invalidBoxFormat',
  INVALID_CITY = 'register.error.invalidCity',
  INVALID_POSTAL_CODE = 'register.error.invalidPostalCode',
  INVALID_STREET = 'register.error.invalidStreet',
  INVALID_HOUSE_NUMBER = 'register.error.invalidHouseNumber',
}

export const IMS_VALIDATION_PROPERTIES = {
  MAX_STREET_LENGTH: 100,
  MAX_HOUSE_NUMBER_LENGTH: 10,
  BOX_NUMBER_LENGTH: 6,
  MAX_CITY_LENGTH: 80,
  MAX_POSTAL_CODE_LENGTH: 9,
  MAX_COUNTRY_CODE_LENGTH: 2,
  // English letters, accented letters, numbers, spaces (\u0020), non-breaking spaces(\u00A0), hyphens(\u002D) and apostrophes(\u0027)
  // No leading, trailing spaces or dashes and no more than one space in a row.
  UNICODE_CITY_REGEX:
    /^[A-Za-zÀ-ÖØ-öø-ÿ\p{N}\u0027]+(?:[\u0020\u00A0\u002D][A-Za-zÀ-ÖØ-öø-ÿ\p{N}\u0027]+)*$/u,
  // English letters, accented letters, numbers, spaces (\u0020), non-breaking spaces(\u00A0), hyphens(\u002D) and apostrophes(\u0027)
  // No leading, trailing spaces or dashes and no more than one space in a row.
  UNICODE_STREET_REGEX:
    /^[A-Za-zÀ-ÖØ-öø-ÿ\p{N}\u0027.]+(?:[\u0020\u00A0\u002D][A-Za-zÀ-ÖØ-öø-ÿ\p{N}\u0027.]+)*$/u,
  // English letters, and numbers, spaces (\u0020), non-breaking spaces(\u00A0), hyphens(\u002D)
  // No leading, trailing spaces or dashes and no more than one space in a row.
  UNICODE_POSTAL_CODE_REGEX: /^[A-Za-z\p{N}]+(?:[\u0020\u00A0\u002D][A-Za-z\p{N}]+)*$/u,
  // English letters, numbers, spaces (\u0020), non-breaking spaces(\u00A0), hyphens(\u002D)
  // No leading, trailing spaces or dashes and no more than one space in a row.
  UNICODE_HOUSE_NUMBER_REGEX: /^[A-Za-z\p{N}]+(?:[\u0020\u00A0\u002D][A-Za-z\p{N}]+)*$/u,
  // English letters, accented letters, numbers, spaces (\s), non-breaking spaces(\u00A0), hyphens(\u002D) and point(\u002E)
  // No leading, trailing spaces or dashes and no more than one space in a row.
  BOX_NUMBER_REGEX:
    /^[A-Za-zÀ-ÖØ-öø-ÿ\p{N}\u002E]+(?:[\u0020\u00A0\u002D][A-Za-zÀ-ÖØ-öø-ÿ\p{N}\u002E]+)*$/u,
};

export interface IValidationProperties {
  maxFirstNameLength: number;
  maxLastNameLength: number;
  maxRawPhoneNumberLength: number;
  maxNickNameLength: number;
  maxPostalCodeRegionalNews: number;
  maxGenderCustomLength: number;
  maxEmailLength: number;
  maxBrandLength: number;
  maxBrandCodeLength: number;
  maxClientIdLength: number;
  maxSubscriptionTypeLength: number;
  maxImportedByLength: number;
  maxStatusLength: number;
  unicodeTextRegex: string;
  minBirthdateYear: number;
  maxBirthdateYearDifferenceFromToday: number;
  phoneRegex: string;
}
